import { NavLink, Outlet } from 'react-router-dom';
import { C } from '../lib/theme.js';

/**
 * Studio — the content-creation workspace. Three tools, each a nested route so
 * deep links (?creative=, ?media=) and the back button keep working:
 *   Compose      — the hub: pick a visual (image OR reel), write the copy, send to Launch
 *   Style image  — optional: lay brand type onto a static image (can't style video)
 *   Library      — your finished posts + a Photos & clips drawer
 * Launch (budget + go live) deliberately stays a separate top-level page.
 */
const TABS = [
  { to: '/studio/copy', label: 'Compose', hint: 'Pick a visual + write the copy' },
  { to: '/studio/create', label: 'Style image', hint: 'Lay brand type on a static image' },
  { to: '/studio/library', label: 'Library', hint: 'Your posts + photos & clips' },
];

export function Studio() {
  return (
    <div>
      <div
        style={{
          display: 'flex',
          gap: 2,
          padding: '0 30px',
          borderBottom: `1px solid ${C.lineSoft}`,
          background: C.base,
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to} title={t.hint} style={{ textDecoration: 'none' }}>
            {({ isActive }) => (
              <div
                style={{
                  padding: '15px 16px 13px',
                  fontSize: 13.5,
                  fontWeight: 600,
                  color: isActive ? C.primary : C.muted,
                  borderBottom: `2px solid ${isActive ? C.basil : 'transparent'}`,
                  marginBottom: -1,
                  cursor: 'pointer',
                }}
              >
                {t.label}
              </div>
            )}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
